export default __webpack_public_path__ + "static/how-hometown-works-icon-0-9c3f85b7bc96f198b94b23e722d963e6.png";